module.exports = __webpack_public_path__ + "assets/img/c91ed9cac4954c314737e88be8a3e4be.png";